import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/AIbuilding',
    name: 'AIbuilding',
    component: () => import('../views/AIbuilding.vue')
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('../views/Business.vue')
  },
  {
    path: '/pre-sales',
    name: 'Pre-sales',
    component: () => import('../views/PreSales.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      index: 4,
    },
    component: () => import('../views/About.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    meta: {
      index: 3,
    },
    component: () => import('../views/Pricing.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: {
      index: 4,
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    meta: {
      index: 5,
    },
    component: () => import('../views/Faq.vue')
  },
  {
    path: '/supportTools',
    name: 'SupportTools',
    meta: {
      index: 0,
    },
    component: () => import('../views/SupportTools.vue')
  },
  {
    path: '/developTools',
    name: 'DevelopTools',
    meta: {
      index: 0,
    },
    component: () => import('../views/DevelopTools.vue')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    meta: {
      index: -1,
    },
    component: () => import('../views/PrivacyPolicy.vue')
  },
  {
    path: '/useTerms',
    name: 'useTerms',
    meta: {
      index: -1,
    },
    component: () => import('../views/UseTerms.vue')
  },
  // {
  //   path: '/solutionGenerationPlatform',
  //   name: 'solution',
  //   meta: {
  //     index: 0,
  //   },
  //   component: () => import('../views/supportProducts/solution.vue')
  // },
  // {
  //   path: '/painPoints',
  //   name: 'painPoints',
  //   meta: {
  //     index: 0,
  //   },
  //   component: () => import('../views/supportProducts/painPoints.vue')
  // },
  {
    path: '/marketAnalytics',
    name: 'marketAnalytics',
    meta: {
      index: 0,
    },
    component: () => import('../views/developProducts/marketAnalytics.vue')
  },
  {
    path: '/globalCustomer',
    name: 'globalCustomer',
    meta: {
      index: 0,
    },
    component: () => import('../views/developProducts/globalCustomer.vue')
  },
  {
    path: '/customerInsights',
    name: 'customerInsights',
    meta: {
      index: 0,
    },
    component: () => import('../views/developProducts/customerInsights.vue')
  },
  // {
  //   path: '/smartPoster',
  //   name: 'smartPoster',
  //   meta: {
  //     index: 0,
  //   },
  //   component: () => import('../views/developProducts/smartPoster.vue')
  // },
  {
    path: '/speechTranslator',
    name: 'speechTranslator',
    meta: {
      index: 0,
    },
    component: () => import('../views/developProducts/speechTranslator.vue')
  },
  {
    path: '/smartEmail',
    name: 'smartEmail',
    meta: {
      index: 0,
    },
    component: () => import('../views/developProducts/smartEmail.vue')
  },
  // {
  //   path: '/strategyCoach',
  //   name: 'strategyCoach',
  //   meta: {
  //     index: 0,
  //   },
  //   component: () => import('../views/developProducts/strategyCoach.vue')
  // },

  // version 2025.12.15
  {
    path: '/businessOpportunity',
    name: 'businessOpportunity',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/businessOpportunity.vue')
  },
  {
    path: '/aiProspecting',
    name: 'aiProspecting',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/prospecting.vue')
  },
  // 客户分析
  {
    path: '/customerAnalysis',
    name: 'customerAnalysis',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/customerAnalysis.vue')
  },
  {
    path: '/strategyCoach',
    name: 'strategyCoach',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/strategyCoach.vue')
  },
  {
    path: '/painPoints',
    name: 'painPoints',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/painPoints.vue')
  },
  {
    path: '/smartPoster',
    name: 'smartPoster',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/smartPoster.vue')
  },
  {
    path: '/solutionGenerationPlatform',
    name: 'solution',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/solution.vue')
  },
  {
    path: '/simulation',
    name: 'simulation',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/simulation.vue')
  },
  {
    path: '/training',
    name: 'training',
    meta: {
      index: 0,
    },
    component: () => import('../views/Products/training.vue')
  },
  // 解决方案
  {
    path: '/software',
    name: 'software',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/software.vue')
  },
  {
    path: '/manufacturing',
    name: 'manufacturing',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/manufacturing.vue')
  },
  {
    path: '/automation',
    name: 'automation',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/automation.vue')
  },
  {
    path: '/logistics',
    name: 'logistics',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/logistics.vue')
  },
  {
    path: '/engineering',
    name: 'engineering',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/engineering.vue')
  },
  {
    path: '/energy',
    name: 'energy',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/industry/energy.vue')
  },
  {
    path: '/saleTeams',
    name: 'saleTeams',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/role/saleTeams.vue')
  },
  {
    path: '/preSaleTeams',
    name: 'preSaleTeams',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/role/preSaleTeams.vue')
  },
  {
    path: '/partners',
    name: 'partners',
    meta: {
      index: 1,
    },
    component: () => import('../views/solveSolutions/role/partners.vue')
  },
  // resources
  {
    path: '/findingProspects',// 对某个客户背景不了解怎么办？
    name: 'findingProspects',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/findingProspects.vue')
  },
  {
    path: '/clientInsight',// 对某个客户背景不了解怎么办？
    name: 'clientInsight',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/clientInsight.vue')
  },
  {
    path: '/unclearRequirements',// 客户需求不清晰怎么办？
    name: 'unclearRequirements',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/unclearRequirements.vue')
  },
  {
    path: '/enablement',// 新人或者合作伙伴如何快速掌握业务？
    name: 'enablement',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/enablement.vue')
  },
  {
    path: '/credibility',// 如何快速建立客户对你的专业印象？
    name: 'credibility',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/credibility.vue')
  },
  {
    path: '/handlingObjections',// 遇到客户的挑战/质疑如何应对？
    name: 'handlingObjections',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/handlingObjections.vue')
  },
  {
    path: '/managingDemands',// 如何高效应对多个客户的产品/方案需求？
    name: 'managingDemands',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/managingDemands.vue')
  },
  {
    path: '/reducingCosts',// 如何减少商机转化的差旅成本?
    name: 'reducingCosts',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/reducingCosts.vue')
  },
  {
    path: '/demoCosts',// 产品演示成本过高怎么办？
    name: 'demoCosts',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/demoCosts.vue')
  },
  {
    path: '/salesOpportunities',// 商机推进不下去了怎么办？
    name: 'salesOpportunities',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/salesOpportunities.vue')
  },
  {
    path: '/handlingThreats',// 遇到竞争对手冲击怎么办？
    name: 'handlingThreats',
    meta: {
      index: 2,
    },
    component: () => import('../views/resources/problems/handlingThreats.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
